import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "concurrent" }

import { watch, reactive, withDefaults, ref, onUnmounted } from 'vue';
import { Bar } from '@antv/g2plot';
import type { Concurrent } from '../types';


const __default__ = {
  name: 'ConcurrentChar',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dataSource: { default: () => ({
      used_count: 0, // 使用总数
      total: 0,
      unused: 0, // 未使用
      used: 0, // 国内
      used_en: 0, // 国外
      status: 0,
    }) }
  },
  setup(__props: any) {

const props = __props as { dataSource: Concurrent };


const currentCharData = reactive([
  {
    name: '剩余',
    value: 100,
    type: '并发数',
  },
  {
    name: '国际/港澳台',
    value: 0,
    type: '并发数',
  },
  {
    name: '中国内地',
    value: 0,
    type: '并发数',
  },
]);
const bar = ref<Bar>();
const charRender = () => {
  bar.value = new Bar('concurrent', {
    data: currentCharData,
    // isPercent: true,
    isStack: true,
    xField: 'value',
    yField: 'type',
    seriesField: 'name',
    // padding: [-45, 0, 0, 0],
    height: 60,
    xAxis: false,
    yAxis: false,
    minBarWidth: 18,
    maxBarWidth: 18,
    // 自定义颜色 绿 黄 蓝 灰
    color: ['#FF9337', '#00CCB0', '#F0F2F5'],
    legend: {
      position: 'bottom-left',
      // offsetY: 10,
      marker: {
        symbol: 'circle',
      },
    },
  });
  bar.value.render();
};
watch(props.dataSource, () => {
  const data = props.dataSource;
  currentCharData[0].value = data.unused;
  currentCharData[1].value = data.used_en;
  currentCharData[2].value = data.used;
  charRender();
});
onUnmounted(() => {
  bar.value && bar.value.destroy();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})